$(function() {






  /* Quantity select on cart page */

  $('.js-update-cart').on('change', function (e) {

    var newQuantity = this.value;
    var index = $(this).closest('.js-cart-line-item').index();

    CartJS.updateItem(index, newQuantity);

    e.preventDefault();
  });

  /* //////////////////// */






  /* Quantity select on cart page */

  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  var header = document.getElementById('order-bar');

  var checkScroll = function() {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  var toggleHeader = function(direction, curScroll) {
    if (direction === 2 && curScroll > 52) {

      //replace 52 with the height of your header in px

      header.classList.add('visible');
      prevDirection = direction;
    }
    else if (direction === 1) {
      header.classList.remove('visible');
      prevDirection = direction;
    }
  };

  window.addEventListener('scroll', checkScroll);

  /* //////////////////// */




  /* Sticky Nav */

  if ($('.collection-nav').length) {
    // When the user scrolls the page, execute myFunction 
    window.onscroll = function() {myFunction()};

    // Get the navbar
    var navbar = document.getElementById("collectionnav");

    // Get the offset position of the navbar
    var sticky = navbar.offsetTop;

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky")
      } else {
        navbar.classList.remove("sticky");
      }
    }

  }

  /* ////////////////////// */






  setTimeout(function() {
    $('body').addClass('loaded');
  }, 1125);

});
